import React from "react";
import "./EliteVacancesFooter.css";
import { ReactComponent as LogoSVG } from "assets/patterns/eliteVacances.svg";
import { ReactComponent as PaySVG } from "assets/patterns/Pagos.svg";
import { ReactComponent as mercadoPago } from "assets/patterns/logo-mercado-pago.svg";
import { ReactComponent as bancolombia } from "assets/patterns/bancolombia.svg";
import pse from "../../assets/patterns/pse-logo.png";
import { NavLink } from "react-router-dom";
import { PhoneOutgoing } from "lucide-react";
import { Mail } from "lucide-react";
import { Send } from "lucide-react";
import { MapPinned } from "lucide-react";
import { CalendarClock } from "lucide-react";
import { Clock } from "lucide-react";

const policyLinks = [
  {
    label: "SAGRILAFT y PTEE",
    to: "/sagrilaft",
    type: "nav",
  },
  {
    label: "DIVULGACIÓN SAGRILAFT y PTEE",
    href: "https://storage.elitevacances.com/files/DIVULGACION_SAGRILAFT_PTEE.pdf",
    type: "external",
  },
  {
    label: "SAGRILAFT y PTEE",
    href: "https://storage.elitevacances.com/files/politica_general_sagrilaft_y_ptte.pdf",
    type: "external",
  },
  {
    label: "Términos y condiciones",
    to: "/terminos-y-condiciones",
    type: "nav",
  },
  {
    label: "Política de tratamiento de datos personales",
    href: "https://assets.elitevacances.com/TRATAMIENTO_DATOS_PERSONALES.pdf",
    type: "external",
  },
  {
    label: "Aviso de privacidad",
    href: "https://assets.elitevacances.com/AVISO_PRIVACIDAD.pdf",
    type: "external",
  },
  {
    label: "Política ley de retracto",
    to: "/politica-de-ley-de-retracto",
    type: "nav",
  },
  {
    label: "Política de protección a menores",
    to: "/politica-de-proteccion-de-menores",
    type: "nav",
  },
  {
    label: "Superintendencia de Industria y Comercio",
    href: "https://sedeelectronica.sic.gov.co/",
    type: "external",
  },
];

const customerService = [
  {
    id: "pqrs",
    label: "PQRS",
    to: "/pqrs",
    icon: "chevron",
    variant: "link",
  },
  {
    id: "linea-etica",
    label: "Línea ética",
    to: "/linea-etica",
    icon: "chevron",
    variant: "link",
  },
  {
    id: "pagos",
    label: "Estado de mi cuenta",
    to: "/pagos",
    icon: PaySVG,
    variant: "button",
  },
  {
    id: "mercadoPago",
    to: "/pagos",
    icon: mercadoPago,
    variant: "button",
  },
  {
    id: "bancolmbia",
    to: "/pagos",
    icon: bancolombia,
    variant: "button",
  },
  {
    id: "pse",
    to: "/pagos",
    icon: pse,
    variant: "button",
  },
];
const year = new Date().getFullYear();

const EliteVacancesFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-prewave" />
      <div className="wave-container">
        <svg
          className="wave-svg"
          preserveAspectRatio="none"
          viewBox="0 0 1200 120"
        >
          <path
            className="wave-path"
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
          />
        </svg>
      </div>

      <div className="footer-gradient" />

      <div className="decorations">
        <div className="bird bird-1">
          <svg fill="currentColor" viewBox="0 0 512 512">
            <path d="M166.3 226.5c-3.2-6.6-11.2-9.4-17.9-6.2l-3.5 1.7C91.1 247.9 48 249.7 19.3 228.3c-6.2-4.6-14.8-3.4-19.4 2.8s-3.4 14.8 2.8 19.4c12.2 9.1 27 16.2 43.6 21.1C23.9 278.4 6.7 289.4 2.5 301.5c-2.6 7.4 1.3 15.5 8.8 18.1s15.5-1.3 18.1-8.8c1.3-3.7 4.7-6.9 11-9.3 27 25.1 71.7 26.6 118.8 3.9l3.5-1.7c6.6-3.2 9.4-11.2 6.2-17.9-1.9-4-5.6-6.8-9.9-7.5-30.6-5.1-66.2-6.5-103.8-16.2 36.3-4.5 70.8-13.4 102.5-29.1 2.9-1.5 5-4.2 6.6-7.1zm328.2 24.6c-4.6-6.2-13.3-7.4-19.4-2.8-28.7 21.4-71.8 19.6-125.6-6.4l-3.5-1.7c-6.6-3.2-14.7-.3-17.9 6.2-1.6 3.3-1.6 7.1 0 10.4 31.7 15.7 66.2 24.6 102.5 29.1-37.6 9.8-73.2 11.2-103.8 16.2-4.3.7-8 3.5-9.9 7.5-3.2 6.6-.3 14.7 6.2 17.9l3.5 1.7c47.1 22.7 91.8 21.2 118.8-3.9 6.2 2.4 9.7 5.6 11 9.3 2.6 7.4 10.7 11.4 18.1 8.8s11.4-10.7 8.8-18.1c-4.2-12.1-21.4-23.1-43.8-29.9 16.6-5 31.4-12 43.6-21.1 6.2-4.6 7.4-13.3 2.8-19.4z" />
          </svg>
        </div>
        <div className="bird bird-2">
          <svg fill="currentColor" viewBox="0 0 512 512">
            <path d="M166.3 226.5c-3.2-6.6-11.2-9.4-17.9-6.2l-3.5 1.7C91.1 247.9 48 249.7 19.3 228.3c-6.2-4.6-14.8-3.4-19.4 2.8s-3.4 14.8 2.8 19.4c12.2 9.1 27 16.2 43.6 21.1C23.9 278.4 6.7 289.4 2.5 301.5c-2.6 7.4 1.3 15.5 8.8 18.1s15.5-1.3 18.1-8.8c1.3-3.7 4.7-6.9 11-9.3 27 25.1 71.7 26.6 118.8 3.9l3.5-1.7c6.6-3.2 9.4-11.2 6.2-17.9-1.9-4-5.6-6.8-9.9-7.5-30.6-5.1-66.2-6.5-103.8-16.2 36.3-4.5 70.8-13.4 102.5-29.1 2.9-1.5 5-4.2 6.6-7.1zm328.2 24.6c-4.6-6.2-13.3-7.4-19.4-2.8-28.7 21.4-71.8 19.6-125.6-6.4l-3.5-1.7c-6.6-3.2-14.7-.3-17.9 6.2-1.6 3.3-1.6 7.1 0 10.4 31.7 15.7 66.2 24.6 102.5 29.1-37.6 9.8-73.2 11.2-103.8 16.2-4.3.7-8 3.5-9.9 7.5-3.2 6.6-.3 14.7 6.2 17.9l3.5 1.7c47.1 22.7 91.8 21.2 118.8-3.9 6.2 2.4 9.7 5.6 11 9.3 2.6 7.4 10.7 11.4 18.1 8.8s11.4-10.7 8.8-18.1c-4.2-12.1-21.4-23.1-43.8-29.9 16.6-5 31.4-12 43.6-21.1 6.2-4.6 7.4-13.3 2.8-19.4z" />
          </svg>
        </div>

        <div className="palm-tree">
          <svg
            width="200px"
            height="200px"
            viewBox="0 0 128 128"
            aria-hidden="true"
            role="img"
            className="iconify iconify--noto"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M69.69 64.8s-.37-6.3-.97-8.02c-1.55-4.4-1.42-11.99 5.02-11.54c6.45.45 4.95 7.72 3.67 11.62c-1.27 3.9-.67 8.09-.67 8.09l-7.05-.15z"
              fill="#ff9003"
            ></path>
            <path
              d="M58.6 65.24c.07-.3-.37-4.95.07-8.84s2.55-9.97-3.45-11.02s-8.52 7.02-6.05 12.64s2.6 8.34 2.6 8.34l6.83-1.12z"
              fill="#ff9003"
            ></path>
            <path
              d="M42.56 26.72c4.8-3.4 15.09-7.09 16.09-5.2c1 1.9-8.59 8.69-8.59 8.69s2.7 5.1 2.7 6.5s.1 4.9-1.5 6.1s-13.19 8.49-13.19 8.49s-.09 1.46-.5 2.6c-.8 2.22-2 2.9-2 2.9l-.7 5.3l3.9 8.39l7.49 28.98l-4.4 2.8s-7.09-1.9-8.69-2c-1.6-.1-4.5-.4-5.2-.1c-.7.3-.9-3.5-.9-3.5s4.4-3.4 4.3-4.3s-2.9-.97-4.4-1.12c-1.5-.15-5.32.45-5.7-.15s-.3-2.85 1.2-3.52s6.6-2.77 6.67-3.37s-5.12-1.67-8.47-2.72c-3.24-1.02-5-1.6-7.42-2.22c-1.74-.45-4.12-.37-4.12-.37l3.6-4.72l16.94 1.95s-7.94-6.15-9.14-7.27s-2.32-2.32-2.32-2.32s1.42-.97 2.7-.67s8.84 6.6 8.84 6.6s-.15-2.4.45-3.45c.6-1.05 1.27-1.27 1.27-1.27s1.12.9 1.5.37c.37-.52-1.65-2.7-2.4-4.65c-.75-1.95-.75-3.22-.75-3.22s-3.75-.9-4.35-5.85s5.02-8.24 5.02-8.24l12.07-19.44z"
              fill="#fa1c1f"
            ></path>
            <path
              d="M69.84 21.75c-.75 2.95 5.85 9.32 5.85 9.32l-.15 2.4s-2.25 5.85-.6 7.94c1.65 2.1 8.32 3.9 8.32 3.9l7.87 7.94s2.4 3.07 3.37 4.05c.97.97-4.57 7.94-4.57 7.94l-2.85 22.48l2.4 12.22l11.79-1.12s-.85-2.32-1.22-3.45c-.37-1.12-4.27-4.57-4.27-4.57s1.72-1.87 4.72-2.02c3-.15 6 1.12 5.62 0c-.37-1.12-1.87-3.45-1.87-3.45l-6.6-2.62s3.52-2.17 5.92-3.07s10.19-2.85 11.24-3.22c1.05-.37 4.5.52 3.37-1.42c-1.12-1.95-7.12-1.95-7.12-1.95l-12.89 1.2s2.62-2.77 5.47-4.8c2.85-2.02 7.49-5.32 7.49-5.32L107.32 63l-10.34 3.67s-2.32 1.57-2.32.52s4.4-2.82 5.9-6.12c1.07-2.36.17-3.4.17-3.4s2.25-1.12 2.4-4.65c.15-3.52-2.62-7.27-2.62-7.27L78.39 23.13s-7.99-3.55-8.55-1.38z"
              fill="#fa1c1f"
            ></path>
            <path
              d="M34.17 57.63c-2.59 1.16-1.72 4.4-1.2 5.82s2.1 4.35 2.1 4.35s-1.5 2.92-1.87 4.2c-.37 1.27-1.2 6.52.37 11.62c1.57 5.1 5.1 12.82 6 14.24s3.9 6.82 10.34 9.89s14.31 2.96 20.16 2.55c7.49-.52 14.54-5.1 15.81-6.97c1.27-1.87 4.05-3.3 5.62-8.92c1.57-5.62 3.15-14.09 2.7-20.01c-.45-5.92-2.55-8.47-2.55-8.47s2.7-1.27 4.27-3.37s2.3-4.55.12-5.37c-2.17-.82-5.57 1.47-6.42 2.6c-1.3 1.72-2.02 3.52-2.02 3.52s-16.42-.15-23.98.22c-12.07.6-18.51 2.02-18.51 2.02l-5.17.22s-.22-10.62-5.77-8.14z"
              fill="#ff5f00"
            ></path>
            <path
              d="M8.19 71.04c-1.41-1.04.8-4.1 4.65-6.7c3.85-2.6 6.15-3.45 7.89-3.15c1.75.3 6.5 3.35 8.59 4.75c1.79 1.2 3.7 2.2 3.75 2.5c.05.3-.93.09-2 1.85c-.57.95-1.2 2.85-1.05 2.75c.15-.1-9.34-5.92-10.14-5.92s-5 2.17-6.4 2.67c-1.39.5-4.14 2.1-5.29 1.25z"
              fill="#ff5f00"
            ></path>
            <path
              d="M.42 85.85c.37.88 2.05 1.1 5.2-1.05s7.34-6.65 8.19-6.89s7.24.9 10.74 1.4c3.5.5 5.55 1 5.55 1l-.25-4.1s-9.89-2.85-13.24-3.25c-3.35-.4-3.7-1-5.55-.2S5.01 78.61 3.87 80S.02 84.91.42 85.85z"
              fill="#ff5f00"
            ></path>
            <path
              d="M20.66 84.16c-2.2.45-8.79 5.85-9.99 7.89c-1.2 2.05-4 8.59-4.65 11.04c-.65 2.45.8 2.5 2.3 1.9s5.3-6.45 6-7.44c.7-1 3.95-3.6 4.95-4.5c1-.9 4-3.5 4.7-3.65c.7-.15 7.99.65 8.34.25c.35-.4-.15-2.1-.7-3.05c-.55-.95-2.37-2.02-2.37-2.02s-6.89-.77-8.58-.42z"
              fill="#ff5f00"
            ></path>
            <path
              d="M32.15 93.4c-2.35-.6-7.14 1-8.49 1.8c-1.35.8-2.8 3-3.55 6.25s-1.7 8.69-.95 9.09c.75.4 3.7-1 4.9-3.8c1.2-2.8 2.75-5.65 3.95-6.6c1.2-.95 3.15-1.35 4.9-1.35h3.9s-1.6-2.9-1.95-3.7c-.36-.79-1.24-1.31-2.71-1.69z"
              fill="#ff5f00"
            ></path>
            <path
              d="M45.09 70.27c-1.65-2.05-4.55-.3-6.4 2.25c-1.85 2.55-2.2 3.75-1.9 8.44c.3 4.7 4.55 5.15 4.6 1.8c.05-3.35-.55-4.35.55-5.95c1.1-1.6 4.86-4.42 3.15-6.54z"
              fill="#ff9003"
            ></path>
            <path
              d="M39.44 90c1.14 1.4 4.35.95 4.6-1.4c.25-2.35-1.3-3-2.95-3c-2.36.01-2.95 2.8-1.65 4.4z"
              fill="#ff9003"
            ></path>
            <path
              d="M95.55 67.44s.65.57 1.15 1.62c.56 1.18.67 1.75.85 2c.22.31 8.24-6.35 10.54-6.75c2.3-.4 8.04 3.7 10.44 4.1c1.89.31 3.35-.1 2.15-2.05c-1.2-1.95-8.14-7.69-11.14-7.44c-3.48.29-13.44 8.12-13.99 8.52z"
              fill="#ff5f00"
            ></path>
            <path
              d="M98.17 74.24s13.65-5.22 16.81-4.57c3.65.75 6.92 5.72 8.14 6.99c1.37 1.42 5.8 6.1 3.35 6.99c-4.11 1.51-11.59-7.84-12.84-8.44s-2-.25-5.4.3s-10.43 2.65-10.43 2.65c-.02.01.19-1.5.22-2.12c.03-.6.15-1.8.15-1.8z"
              fill="#ff5f00"
            ></path>
            <path
              d="M97.55 82.21c-.33.33-.56 2.46-.65 2.95c-.15.8-.35 2.1-.35 2.1s7.24.15 7.94.45c.7.3 2.95 2.62 4.8 4.25c1.42 1.24 5.65 5.35 5.65 5.35s3.2 6.35 5.15 6.4c1.95.05 1.95-2.65 1.05-5.1c-.9-2.45-2.2-6.6-2.7-7.09c-.5-.5-2.25-3-4.35-5.1c-1.03-1.03-4.8-4.3-5.8-4.45c-1-.16-10.04-.46-10.74.24z"
              fill="#ff5f00"
            ></path>
            <path
              d="M95.75 90.58s6.94 1.07 9.49 3.32c1.55 1.37 3.37 5.27 3.7 8.49c.1 1.01.75 7.14-.95 7.39s-4.02-3.22-4.67-5.02s-1.82-4.97-1.82-4.97s-3.23-1.93-3.4-2c-1.2-.47-4.9-.55-4.9-.55s1.24-2.24 1.65-3.4c.5-1.41.9-3.26.9-3.26z"
              fill="#ff5f00"
            ></path>
            <path
              d="M34.85 26.4c-7.69 4.85-12.02 18.09-4.6 23.58c8.09 6 19.24-2.7 24.13-9.29s7.29-9.99 5.8-12.04s-8.69 4.3-8.69 4.3s.65 2.25.55 4.85c-.1 2.6-.3 5.05-1.45 5.05s-1.05-3.85-2.15-7.14s-2.25-3.7-2.2-5c.05-1.3 5.85-4.56 7.32-5.42c3.17-1.87 5.85-3.47 4.57-4.22c-1.05-.64-11.83-1.88-23.28 5.33z"
              fill="#ff5f00"
            ></path>
            <path
              d="M31.4 44.58c3.48-.41 1.87-3.88 2.65-6.7c.95-3.45 3.95-5.35 1.7-7.29c-2.47-2.14-5.25 2.01-6.15 6.5c-.55 2.75-.75 7.79 1.8 7.49z"
              fill="#ff9003"
            ></path>
            <path
              d="M79.81 32.74c.05.95-2.45 1.85-3.15 5.2c-.7 3.35-.75 6.1 4.95 10.39s12.89 8.14 17.74 2.55s2.6-16.84-6.5-24.08c-7.39-5.88-17.64-7.53-21.98-6c-2.55.9 2 3.55 4.65 6.15c3.11 3.06 4.24 4.84 4.29 5.79z"
              fill="#ff5f00"
            ></path>
            <path
              d="M68.87 29.22c-.89.94-.28 4.45 1.4 6.75c1.35 1.85 4.5 5.05 4.5 5.05s-.6-4.15-.2-5.05s.2-2.8.2-2.8s-1.6-1.45-2.5-2.2s-2.55-2.65-3.4-1.75z"
              fill="#ff5f00"
            ></path>
            <path
              d="M79.61 36.54c-1.8.3-1.22 3.16 0 5.7c1.25 2.6 3.3 3.75 4.55 2.7s-.15-3.35-.9-4.7s-1.85-4-3.65-3.7z"
              fill="#ff9009"
            ></path>
            <ellipse
              transform="rotate(-73.43 73.525 52.437)"
              cx="73.53"
              cy="52.44"
              rx="4.32"
              ry="3.35"
              fill="#322d2e"
            ></ellipse>
            <ellipse
              transform="rotate(-5.846 53.773 52.4)"
              cx="53.79"
              cy="52.41"
              rx="3.64"
              ry="4.32"
              fill="#322d2e"
            ></ellipse>
            <path
              d="M77.99 30.1c-.7-1.1-2.91.69-3.85 2.95c-1.1 2.65-1.1 6.3.35 7.79s.1-3.6 1.45-6.3c1.12-2.24 2.75-3.35 2.05-4.44z"
              fill="#a62616"
            ></path>
            <path
              d="M47.94 28.85c-.78.78.35 1.15 1 2.8s1.2 2.9 1.55 4.95c.27 1.58.05 6.87 1.15 5.32c1.1-1.55 1.32-8.07-.15-10.57c-1.31-2.2-2.66-3.4-3.55-2.5z"
              fill="#a62616"
            ></path>
            <path
              d="M82.16 63.62c.27 1.09 4.2.65 6.75 2.05s4.5 4.9 4.35 12.09c-.16 7.2-2.26 15.18-2.61 16.34c-.85 2.85-3.9 7.84-4.45 8.54s-1.82 2.27.5.65c2.55-1.78 3.5-3.2 3.5-3.2s4.55.15 4.7-.75c.15-.9-3.7-1.35-3.7-1.35s.8-1.55 1.45-3.55c.65-2 1.15-3.85 1.15-3.85s1.15.02 3.67-.25c2.77-.3 6.77-.4 7.27-1.2c.62-.99-4.12-.8-6.55-.57c-1.98.18-4.05.07-4.05.07s.35-1.97.55-3.22c.2-1.25.32-2.8.32-2.8s4.92-1.15 6.47-1.65c1.55-.5 6.8-2.17 6.75-2.92c-.04-.55-4.05.15-6.87.85c-2.42.6-6.32 1.45-6.32 1.45s.15-2.25.25-3.4s0-2.45 0-2.45s1.8.2 2.87-.27s2.7-2.24 3.97-3.12c1.4-.97 5.27-3.7 5.02-4.35c-.28-.73-5.02 2.05-6.5 3.07c-1.14.79-2.82 2.22-3.67 2.37c-.85.15-1.8.25-1.8.25s-.7-2.95-1.05-4.05c-.35-1.1-1.55-3.4-3.5-4.6s-9.07-2.63-8.47-.18z"
              fill="#a62616"
            ></path>
            <path
              d="M36.79 66.12c-3.1 1.05-5 4.25-5.25 6.35c-.25 2.1-.1 2.9-.1 2.9s-3.4-2.4-4.7-3.5c-.9-.76-6.97-5.7-7.67-4.55c-.7 1.15 6.07 6.15 6.77 6.85c.7.7 5.5 4.05 5.5 4.05l.6 3.2s-1.67.5-3.32.65c-1.65.15-8.41-2.62-8.62-.82c-.05.42 7.9 2.81 8.49 2.92c1.27.25 4.4-.15 4.4-.15s1 3.22 1.2 3.82c.2.6 1.07 2.9 1.07 2.9s-2.82.07-3.67.02c-1.32-.07-6.51-.53-6.7.45c-.12.65 5.5 1.05 7.29 1.35c1.8.3 3.9.55 3.9.55s1.02 2.37 1.82 3.57c.8 1.2 2.52 3.7 2.52 3.7s-7.11-1.23-6.85-.02c.15.67 8.44 2.85 8.44 2.85s8.26 5.36 9.36 5.11c1.14-.26-2.85-1.95-6.11-5.26c-2.13-2.17-5.42-6.5-7.52-11.59c-.85-2.06-4.22-12.68-4.02-16.29c.2-3.65 1.65-5.65 3.85-6.65s9.84-2 8.29-3.2c-1.52-1.21-6.98.12-8.97.79z"
              fill="#a32916"
            ></path>
          </svg>
        </div>
        <div>
          <h2 className="footer-title">Elite Vacances</h2>
          {/* describe la compañia*/}
        </div>
        <div className="surfboard">
          <div className="surfboard-inner">
            <div className="surfboard-stripe"></div>
            <div className="surfboard-line"></div>
          </div>
        </div>
      </div>

      <div className="footer-content">
        <div className="footer-grid">
          {/* <div className="footer-section">
            <div className="social-links">
              <a
                href="https://facebook.com/elitevacances"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookSVG className="social-link" />
              </a>
              <a
                href="https://www.instagram.com/elitevacances/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramSVG className="social-link" />
              </a>
              <a
                href="https://www.tiktok.com/@elitevacances"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TikTokSVG className="social-link" />
              </a>
            </div>
          </div> */}

          <div className="footer-section">
            <h3 className="footer-title">
              Políticas
              <span className="title-underline"></span>
            </h3>
            <ul className="link-list">
              {policyLinks.map((item) => (
                <li key={item.label}>
                  {item.type === "nav" ? (
                    <NavLink to={item.to} className="destination-link">
                      <i className="fa-solid fa-chevron-right chevron-icon"></i>
                      <span>{item.label}</span>
                    </NavLink>
                  ) : (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="destination-link"
                    >
                      <i className="fa-solid fa-chevron-right chevron-icon"></i>
                      <span>{item.label}</span>
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">
              Canales de Atención
              <span className="title-underline"></span>
            </h3>
            <ul className="link-list">
              {/* Línea Nacional */}
              <li className="contact-item">
                <div className="icon-circle">
                  <PhoneOutgoing size={20} />
                </div>
                <div>
                  <span className="contact-label">Línea Nacional</span>
                  <a className="hover:underline" href="tel:+5717945996">
                    +57 (1) 7945996
                  </a>
                </div>
              </li>

              {/* WhatsApp */}
              <li className="contact-item">
                <div className="icon-circle">
                  <i className="fa-brands fa-whatsapp"></i>
                </div>
                <div>
                  <span className="contact-label">WhatsApp</span>
                  <a
                    className="hover:underline"
                    href="https://wa.me/5717945996"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    +57 (1) 7945996
                  </a>
                </div>
              </li>

              {/* Email */}
              <li className="contact-item">
                <div className="icon-circle">
                  <Mail size={20} />
                </div>
                <div>
                  <span className="contact-label">Email</span>
                  <a
                    href="mailto:sac@elitevacances.com"
                    className="destination-link"
                  >
                    sac@elitevacances.com
                  </a>
                </div>
              </li>
              <li className="contact-item">
                <div className="icon-circle">
                  <Send size={20} />
                </div>
                <div>
                  <span className="contact-label">Email</span>

                  <a
                    href="mailto:reservas@elitevacances.com"
                    className="destination-link"
                  >
                    reservas@elitevacances.com
                  </a>
                </div>
              </li>
              <li>
                <h6>Oficina PrincipaL</h6>
                <ul>
                  <li className="contact-item">
                    <div className="icon-circle">
                      <MapPinned size={20} />
                    </div>
                    <div>
                      <span className="contact-label">Oficina 302</span>

                      <a
                        href="https://www.google.com/maps/dir//Cl+93b+%23+19-57,+Chapinero,+Bogot%C3%A1,+D.C.,+Bogot%C3%A1,+Bogot%C3%A1,+D.C./@4.6804523,-74.0594699,1552m/data=!3m1!1e3!4m18!1m9!3m8!1s0x8e3f9aecbb633c7f:0x9d9cfb84c0bcf85f!2zQ2wgOTNiICMgMTktNTcsIENoYXBpbmVybywgQm9nb3TDoSwgRC5DLiwgQm9nb3TDoSwgQm9nb3TDoSwgRC5DLg!3b1!8m2!3d4.680447!4d-74.054599!15sChFDYWxsZSA5M0IgIyAxOS01N5IBEGdlb2NvZGVkX2FkZHJlc3PgAQA!16s%2Fg%2F11l_60b662!4m7!1m0!1m5!1m1!1s0x8e3f9aecbb633c7f:0x9d9cfb84c0bcf85f!2m2!1d-74.054599!2d4.680447?entry=ttu&g_ep=EgoyMDI2MDMwMi4wIKXMDSoASAFQAw%3D%3D"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Calle 93B # 19-57
                      </a>
                    </div>
                  </li>
                  <p className="contact-label">
                    <br />
                    Bogotá D.C., Colombia
                  </p>
                </ul>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">
              Medios de pago
              <span className="title-underline"></span>
            </h3>
            <ul className="btn-footer">
              {customerService
                .filter((item) => item.variant === "button")
                .map(({ id, label, to, icon: Icon }) => (
                  <li key={id}>
                    <NavLink to={to} className="btn-footer-pay">
                      {typeof Icon === "string" ? (
                        <img
                          src={Icon}
                          className="pay-icon"
                          alt={label || id}
                        />
                      ) : (
                        <Icon className="pay-icon" />
                      )}
                      {label && <span>{label}</span>}
                    </NavLink>
                  </li>
                ))}
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">
              Servicio al Cliente
              <span className="title-underline"></span>
            </h3>
            <ul className="link-list">
              <ul className="link-list">
                {customerService
                  .filter((item) => item.variant === "link")
                  .map(({ id, label, to, icon }) => (
                    <li key={id}>
                      <NavLink to={to} className="destination-link">
                        {icon === "chevron" && (
                          <i className="fa-solid fa-chevron-right chevron-icon"></i>
                        )}
                        <span>{label}</span>
                      </NavLink>
                    </li>
                  ))}
              </ul>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">
              Horario de Atención
              <span className="title-underline"></span>
            </h3>

            <ul>
              <li className="contact-item">
                <div className="icon-circle">
                  <CalendarClock size={20} />
                </div>
                <div>
                  <span className="contact-label">Lunes a viernes:</span>
                  <p> 8:00 AM - 7:00 PM</p>
                </div>
              </li>
              <li className="contact-item">
                <div className="icon-circle">
                  <Clock size={20} />
                </div>
                <div>
                  <span className="contact-label">Sábados: </span>
                  <p> 9:00 AM - 3:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom-wrapper">
        <div className="brand-container">
          <LogoSVG />
        </div>
        <div className="footer-bottom">
          <p>
            RNT N° 280829 Elite vacances SAS. NIT. 901088947-6. Oficina
            Principal Calle 93B # 19-57 oficina 302 Bogotá. Estamos
            comprometidos con: Ley 679 de 2001 y ley 1336 de 2009. Contra la
            explotación, la pornografía, el turismo sexual y otras formas de
            abuso a los menores. Decreto 2737 de 1989. Por el cual se expide el
            código del menor y en la cual está en contra de la explotación
            laboral infantil. Ley 397 de 1997. Contra el tráfico de Patrimonio
            Cultural. Ley 599 de 2000, decreto 1608 de 1978 y Ley 1453 de 2011.
            Contra el tráfico de especies como flora y fauna silvestre. Ley 1335
            de 2009. Antitabaco, por un espacio libre de humo del tabaco. Ley
            1482 de 2011. Garantizar la protección de los derechos de una
            persona, grupo de personas, comunidad o pueblo, que son vulnerados a
            tráficos de actos de racismo o discriminación. Damos cumplimiento a
            lo establecido por la Ley 1581 de 2012, sobre protección de datos
            personales.
          </p>
        </div>
      </div>
      <div className="der_reservados">
        <p> © {year} | Todos los derechos reservados. Elite Vacances S.A.S</p>
      </div>
    </footer>
  );
};

export default EliteVacancesFooter;
